import { connect } from "react-redux";

import * as actions from "./actions";

function mapStateToProps(state) {
  return {
    balances: state.specialAccounts.balances.data,
    transactionOrders: state.specialAccounts.transactionOrders.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loanstepSpecialAccountsBalances: () => {
      dispatch(actions.loanstep_special_accounts_balances());
    },
    loanstepGetTransactionOrders: () => {
      dispatch(actions.loanstep_special_accounts_transaction_orders());
    },
    loanstepDeposit: (amount, accountId, notes) => {
      dispatch(actions.loanstep_create_deposit_order(amount, accountId, notes));
    },
    loanstepWithdraw: (amount, accountId, notes) => {
      dispatch(
        actions.loanstep_create_withdrawal_order(amount, accountId, notes),
      );
    },
    loanstepConfirm: (id) => {
      dispatch(actions.loanstep_confirm_transaction_order(id));
    },
    loanstepCancel: (id) => {
      dispatch(actions.loanstep_cancel_transaction_order(id));
    },
  };
}

export const specialAccountsConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
